export default class DoubleCta {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
